import { decodeJwtPayload } from '../../services/decodeJwtPayload';
import { useAuth } from './AuthenticationProvider';
import { isStaffRole, StaffRole } from './staffRole';

/**
 * Resolves the signed-in staff member's tier from the `role` claim of the
 * session JWT the app already holds (COR-545). Returns `undefined` when no one
 * is signed in, the token is malformed, the claim is absent, or the claim is
 * not a recognised tier — fail closed, mirroring the backend. Advisory only:
 * the backend remains the authorization boundary.
 */
export function useStaffRole(): StaffRole | undefined {
  const { authResult } = useAuth();
  const token = authResult?.token;
  if (!token) {
    return undefined;
  }

  const role = decodeJwtPayload(token)?.role;
  return isStaffRole(role) ? role : undefined;
}
